import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import RouterParamsOrderStatusMixin from '@/helpers/vue_mixins/v2/ecommerce/RouterParamsOrderStatusMixin';
import FormMixin from '@/helpers/vue_mixins/FormMixin';
import FormValidationsMixin from '@/helpers/vue_mixins/v2/FormValidationsMixin';
import OrdersExport from '@/components/v2/ecommerce/OrdersExport';
import BaseCsvExporter from '@/components/v2/BaseCsvExporter.vue';
import ActionButton from '@/components/action_button/Index.vue';
import AppCsvExportedAtUpdate from '@/plugins/graphql/mutations/v2/ecommerce/app-csv-exported-at-update.gql';
import AppDetailsMixin from '@/helpers/vue_mixins/v2/ecommerce/AppDetailsMixin';
import moment from 'moment';
import { SHORTDATE_FORMAT } from '@/helpers/constants/app';
import { required, requiredIf } from 'vuelidate/lib/validators';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import { TierType } from '@/helpers/entities/enums/v2/TierType';
import { ExportType } from '@/helpers/entities/enums/v2/ExportType';
import { selectOptionBuilder } from '@/helpers/select_option_builder';
import EcommerceProducts from '@/components/v2/ecommerce/Products';
import OrderExportMailer from '@/plugins/graphql/mutations/v2/ecommerce/export-to-mailer.gql';
import { Bundle } from '@/helpers/entities/enums/v2/Bundle';
let OrderExport = class OrderExport extends Mixins(Mixins(RouterParamsAppMixin, RouterParamsOrderStatusMixin), ViewportSizeMixin, Mixins(FormMixin, FormValidationsMixin), AppDetailsMixin) {
    constructor() {
        super(...arguments);
        this.from = null;
        this.to = null;
        this.dateStart = null;
        this.dateEnd = null;
        this.exportable = false;
        this.proTier = TierType.ProTier;
        this.exportType = ExportType.timeRange;
        this.productUuid = [];
        this.exportInProgress = false;
        this.toggleMenuExport = false;
        this.toggleMultilineExport = false;
        this.toggleAllProducts = false;
    }
    get exportTypeSelection() {
        return [selectOptionBuilder(ExportType.product), selectOptionBuilder(ExportType.timeRange)];
    }
    get timeExport() {
        return this.exportType === ExportType.timeRange;
    }
    get productExport() {
        return this.exportType === ExportType.product;
    }
    get isMultiStore() {
        return this.bundleKey === Bundle.MultiStore;
    }
    get enabledMultipleExport() {
        return this.bundleKey === Bundle.Ecommerce || this.bundleKey === Bundle.Shopify;
    }
    validExport() {
        if (this.exportType === ExportType.product) {
            // return !!this.productUuid;
            return this.productUuid.length > 0 || this.toggleAllProducts;
        }
        return !!this.dateStart && !!this.dateEnd;
    }
    setDefaultDate() {
        const vm = this;
        const startDate = moment(this.today).isoWeekday('Monday').format(SHORTDATE_FORMAT);
        vm.$v.from.$model = startDate;
        this.dateStart = startDate;
        vm.$v.to.$model = this.today;
        this.dateEnd = this.today;
    }
    checkDateValue() {
        if (!!this.$v.from.$model && this.$v.to.$model) {
            this.exportable = true;
        }
        this.exportable = false;
    }
    weekRange(val) {
        const container = [];
        let prevDates = [];
        const date = moment(val).format(SHORTDATE_FORMAT);
        const newDate = moment(val).isoWeekday('Monday').format(SHORTDATE_FORMAT);
        if (date === newDate) {
            container.push(date);
        }
        const checkPrevDates = prevDates.includes(val);
        if (!checkPrevDates) {
            prevDates.push(val);
        }
        else if (prevDates.length > 31) {
            prevDates = [];
            prevDates.push(val);
        }
        return container.includes(val);
    }
    get ninetyDaysBefore() {
        return moment(this.today).subtract(90, 'days').format(SHORTDATE_FORMAT);
    }
    minDateByPlan() {
        const vm = this;
        if (vm.newProTierType === 'basic') {
            return this.ninetyDaysBefore;
        }
        return '';
    }
    get today() {
        return moment().format(SHORTDATE_FORMAT);
    }
    get minDate() {
        return this.dateStart;
    }
    get maxDate() {
        const vm = this;
        if (!this.dateStart) {
            return null;
        }
        const startRange = moment(this.dateStart).format(SHORTDATE_FORMAT);
        const endRange = moment(startRange).add(6, 'd').format(SHORTDATE_FORMAT);
        const maxDateSelection = endRange > this.today ? this.today : endRange;
        vm.$v.to.$model = maxDateSelection;
        this.dateEnd = maxDateSelection;
        return maxDateSelection;
    }
    startOfDate(from) {
        const vm = this;
        vm.$refs.startDate.save(from);
        this.dateStart = from;
    }
    endOfDate(to) {
        const vm = this;
        this.dateEnd = to;
        vm.$refs.endDate.save(to);
    }
    checkOrder(orders) {
        let readyToExport = true;
        if (orders) {
            readyToExport = false;
        }
        return readyToExport;
    }
    alertError(orders) {
        const self = this;
        if (!orders || !orders.length) {
            self.errorNotification('No data to export');
        }
        this.toggleMenuExport = false;
    }
    async markAsExported(message) {
        const self = this;
        await this.$apollo
            .mutate({
            mutation: AppCsvExportedAtUpdate,
            variables: {
                input: {
                    appUuid: self.appUUID,
                },
            },
        })
            .then(() => {
            self.refetchAppDetails();
            this.toggleMenuExport = false;
        })
            .catch((error) => {
            self.errorNotification(error.message);
            self.logError(error.message);
            this.toggleMenuExport = false;
        })
            .finally(() => {
            self.successNotification(message);
            this.toggleMenuExport = false;
        });
    }
    get mutationInput() {
        const input = {
            appUuid: this.appUUID,
            exportType: this.exportType,
        };
        if (!this.isMultiStore) {
            Object.assign(input, { status: this.orderStatus });
        }
        if (this.exportType === ExportType.timeRange) {
            Object.assign(input, {
                startDate: this.dateStart,
                endDate: this.dateEnd,
                separateProducts: this.toggleMultilineExport,
            });
        }
        else if (this.exportType === ExportType.product) {
            if (!this.toggleAllProducts) {
                Object.assign(input, { productUuids: this.productUuid });
            }
            else {
                Object.assign(input, { allProducts: this.toggleAllProducts });
            }
        }
        return input;
    }
    async exportMailer() {
        const self = this;
        if (this.exportType === ExportType.product && !this.toggleAllProducts)
            this.$v.productUuid.$touch();
        if (!this.$v.$invalid) {
            this.exportInProgress = true;
            this.requestOnFlight();
            await this.$apollo
                .mutate({
                mutation: OrderExportMailer,
                variables: {
                    input: self.mutationInput,
                },
            })
                .then((data) => {
                const { orders } = data.data.orderExportMailer;
                if (orders.edges.length > 0) {
                    const emails = self.appEmailNotificationRecipientsList;
                    this.successNotification(`Export will be sent to your emails: ${emails.join(', ')}`);
                }
                else {
                    this.errorNotification('No Data Export');
                }
            })
                .catch((e) => {
                this.errorNotification(e.message);
            })
                .finally(() => {
                this.toggleMenuExport = false;
                this.requestDone();
                this.exportInProgress = false;
            });
        }
    }
    get labels() {
        const self = this;
        const status = self.orderStatus;
        const labels = {
            transactionNumber: 'ChatGenie Reference Number',
            fullName: 'Customer Full Name',
            email: 'Customer Email',
            contactNumber: 'Customer Contact Number',
            deliveryAddress: 'Complete Delivery Address',
        };
        if (self.productTrackable) {
            Object.assign(labels, {
                skuMatCode: 'SKU/Mat Code',
            });
        }
        Object.assign(labels, {
            productName: 'Product Name',
            productVariance: 'Product Variation',
            quantity: 'Quantity',
            orderPlacedAt: 'Order Placed At',
            paymentName: 'Payment Method',
            thirdPartyPaymentReferenceId: 'Payment Reference ID',
            shippingName: 'Shipping Method',
        });
        if (self.withShippingParkAndMunch) {
            const parkAndMunchLabels = {
                plateNumber: 'Plate Number',
                carColor: 'Car Color',
                carModel: 'Car Model',
                landmark: 'Parking Landmark',
            };
            Object.assign(labels, parkAndMunchLabels);
        }
        Object.assign(labels, {
            trackingNumber: 'Tracking Number',
            remarks: 'Order Remarks',
            deliveryCountry: 'Country',
            deliveryRegion: 'Region',
            deliveryCity: 'City',
            deliveryAddressLine1: 'Street',
            deliveryBuilding: 'Building',
            deliveryRoom: 'Room',
            deliveryFloor: 'Floor',
            deliveryBarangay: 'Barangay',
            status: 'Order Status',
            paymentStatus: 'Payment Status',
            promoCode: 'Promo Code',
        });
        const additionalLabels = {
            deliveryFee: 'Delivery / Shipping Fee',
            paymentProviderFee: 'Payment Provider Fee',
            subtotal: 'Item Total',
            transactionFee: 'ChatGenie Convenience Fee',
            grandTotal: 'Grand Total',
            salesChannel: 'Sales Channel',
        };
        if (status === 'for_delivery') {
            Object.assign(labels, {
                humanizedConfirmedAt: 'Order Confirmed At',
            });
        }
        else if (status === 'completed') {
            Object.assign(labels, {
                humanizedConfirmedAt: 'Order Confirmed At',
                completedAtDate: 'Order Mark as Completed At',
            });
        }
        else if (status === 'cancelled') {
            Object.assign(labels, {
                cancelledDate: 'Cancelled Date',
                cancelMessage: 'Cancellation Message',
            });
        }
        if (self.appliesKyc) {
            Object.assign(additionalLabels, this.appliesKycLabels);
        }
        return Object.assign(labels, additionalLabels);
    }
    get appliesKycLabels() {
        return {
            kycLevel: 'Application/Kyc Level',
            identityPhotoUrl: 'Identity Image Link',
            idNumber: 'ID Number',
            idCardType: 'ID Card Type',
            kycTransaction: 'Required for KYC',
            idCardUrl: 'Id Card Image Link',
            proofOfIncomePhotoUrl: 'Proof Of Income Image Link',
            proofOfIncomeType: 'Proof of Income Type',
            completedKycAtDate: 'Completed KYC At',
            kycApprovedAtDate: 'KYC Approved At',
            existingKycRefNo: 'Existing Postpaid Mobile Number',
            salutation: 'Salutation',
            middleName: 'Middle Name',
            birthdate: 'Birthdate',
            mothersMaidenName: `Mother's Maiden Name `,
            nationality: 'Nationality',
            grossMonthlyIncome: 'Gross Monthly Income',
            contactPerson: 'Contact Person',
            contactPersonNumber: 'Contact Person Number',
            contactPersonRelationship: 'Contact Person Relationship',
            sssNo: 'SSS Number',
            gsisNo: 'GSIS Number',
            tinNo: 'Tin Number',
            billMedia: 'Billing Media',
            billingEmail: 'Billing Email',
            billingAddress: 'Billing Address',
            passportIdNo: 'Passport ID Number',
            passportExpiry: 'Passport Expiry',
            employmentType: 'Employment Type',
        };
    }
    get fields() {
        return Object.keys(this.labels);
    }
    get dateSelection() {
        const self = this;
        let dateSelection = 'lg-date-selection';
        if (self.smOnly) {
            dateSelection = 'sm-date-selection';
        }
        else if (self.xsOnly) {
            dateSelection = 'xs-date-selection';
        }
        return dateSelection;
    }
    get vueClass() {
        if (this.xsOnly) {
            return 'pa-0';
        }
        if (this.lgAndDown) {
            return 'px-2';
        }
        return '';
    }
};
OrderExport = __decorate([
    Component({
        components: {
            OrdersExport,
            BaseCsvExporter,
            ActionButton,
            EcommerceProducts,
        },
        validations() {
            const vm = this;
            const timeExport = () => vm.exportType === ExportType.timeRange;
            const productExport = () => vm.exportType === ExportType.product && !this.toggleAllProducts;
            return {
                from: {
                    required: requiredIf(timeExport),
                },
                to: {
                    required: requiredIf(timeExport),
                },
                exportType: {
                    required,
                },
                productUuid: {
                    required: requiredIf(productExport),
                },
            };
        },
    })
], OrderExport);
export default OrderExport;
